// theme.js — sticky header offset, mobile nav, cart count, newsletter guard
(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    // Mobile nav drawer
    var burger = document.querySelector('[data-pb-burger]');
    var nav = document.querySelector('[data-pb-mobilenav]');
    var overlay = document.querySelector('[data-pb-overlay]');
    function close(){ if(nav) nav.classList.remove('is-open'); if(overlay) overlay.classList.remove('is-open'); document.body.classList.remove('pb-noscroll'); }
    function open(){ if(nav) nav.classList.add('is-open'); if(overlay) overlay.classList.add('is-open'); document.body.classList.add('pb-noscroll'); }
    if(burger) burger.addEventListener('click', open);
    if(overlay) overlay.addEventListener('click', close);
    document.querySelectorAll('[data-pb-navclose]').forEach(function(a){ a.addEventListener('click', close); });

    // Sticky header after scrolling past a threshold (with spacer so content doesn't jump)
    var header = document.querySelector('.pb-header');
    if(header){
      var threshold = 220, spacer = null;
      function stick(){
        if(header.classList.contains('pb-header--stuck')) return;
        spacer = document.createElement('div');
        spacer.style.height = header.offsetHeight + 'px';
        header.parentNode.insertBefore(spacer, header.nextSibling);
        header.classList.add('pb-header--stuck');
      }
      function unstick(){
        if(!header.classList.contains('pb-header--stuck')) return;
        header.classList.remove('pb-header--stuck');
        if(spacer && spacer.parentNode){ spacer.parentNode.removeChild(spacer); spacer = null; }
      }
      var onScroll = function(){ if(window.scrollY > threshold){ stick(); } else { unstick(); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Treasure-chest cart icon: open on hover/focus, close again on leave/blur.
    // Steps toward a target frame so an interrupted open closes from where it is.
    document.querySelectorAll('[data-pb-chest]').forEach(function(el){
      var FRAMES = 4, idx = 0, target = 0, timer = null;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function render(){ el.setAttribute('data-frame', String(idx + 1)); }
      function tick(){
        if(idx === target){ clearInterval(timer); timer = null; return; }
        idx += idx < target ? 1 : -1;
        render();
        if(idx === target){ clearInterval(timer); timer = null; }
      }
      function go(t){
        target = t;
        if(reduce){ idx = t; render(); return; }   // jump straight to open/closed
        if(!timer) timer = setInterval(tick, 70);
      }
      el.addEventListener('mouseenter', function(){ go(FRAMES - 1); });
      el.addEventListener('mouseleave', function(){ go(0); });
      el.addEventListener('focus', function(){ go(FRAMES - 1); });
      el.addEventListener('blur', function(){ go(0); });
    });

    // Cart: auto-update quantities on change (Update button removed)
    document.querySelectorAll('.pb-cart__form input[name="updates[]"]').forEach(function(input){
      input.addEventListener('change', function(){ if(input.form){ input.form.submit(); } });
    });

    // Product-card quantity steppers: custom pixel +/- buttons drive the number input
    document.querySelectorAll('[data-pb-qty]').forEach(function(wrap){
      var input = wrap.querySelector('input[type="number"]');
      if(!input) return;
      wrap.querySelectorAll('[data-qty-step]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var min = parseInt(input.min, 10); if(isNaN(min)) min = 0;
          var val = parseInt(input.value, 10); if(isNaN(val)) val = min;
          val += btn.getAttribute('data-qty-step') === 'up' ? 1 : -1;
          if(val < min) val = min;
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // Stat dots renderer: <span class="pb-stat__dots" data-value="4" data-max="5">
    document.querySelectorAll('.pb-stat__dots[data-value]').forEach(function(el){
      var v = parseInt(el.getAttribute('data-value')||'0',10);
      var max = parseInt(el.getAttribute('data-max')||'5',10);
      var html='';
      for(var i=0;i<max;i++){ html += '<span class="pb-stat__dot'+(i<v?' pb-stat__dot--on':'')+'"></span>'; }
      el.innerHTML = html;
    });

    // Animated hand cursor: follows the pointer, presses down on click, ripples + sparkles on click.
    // Only on devices with a fine pointer (mouse/trackpad) — touch keeps the native cursor.
    (function(){
      var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
      var src = document.body.getAttribute('data-pb-cursor-src');
      if(!fine || !src) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var cursor = document.createElement('div');
      cursor.className = 'pb-cursor';
      var img = document.createElement('img');
      img.className = 'pb-cursor__img';
      img.src = src; img.alt = '';
      cursor.appendChild(img);
      document.body.appendChild(cursor);
      document.documentElement.classList.add('pb-has-cursor');

      var x = 0, y = 0, raf = null;
      function render(){ raf = null; cursor.style.transform = 'translate(' + x + 'px,' + y + 'px)'; }
      document.addEventListener('pointermove', function(e){
        if(e.pointerType === 'touch') return;
        x = e.clientX; y = e.clientY;
        cursor.classList.add('is-visible');
        if(!raf) raf = requestAnimationFrame(render);
      }, { passive: true });

      // Hide when the pointer leaves the window
      document.addEventListener('mouseleave', function(){ cursor.classList.remove('is-visible'); });
      window.addEventListener('blur', function(){ cursor.classList.remove('is-visible'); });

      function pressDown(){ cursor.classList.add('is-down'); }
      function release(){ cursor.classList.remove('is-down'); }
      document.addEventListener('pointerdown', function(e){
        if(e.pointerType === 'touch') return;
        pressDown();
        if(!reduce){
          // ripple lands on the fingertip (nudged left); sparkle pops at the hand's top-right
          var fx = e.clientX - 5, fy = e.clientY;
          var r = document.createElement('span');
          r.className = 'pb-ripple';
          r.style.left = fx + 'px';
          r.style.top = fy + 'px';
          document.body.appendChild(r);
          r.addEventListener('animationend', function(){ if(r.parentNode) r.parentNode.removeChild(r); });

          var s = document.createElement('span');
          s.className = 'pb-clicksparkle';
          s.style.left = (e.clientX + 14) + 'px';
          s.style.top = (e.clientY - 3) + 'px';
          document.body.appendChild(s);
          s.addEventListener('animationend', function(){ if(s.parentNode) s.parentNode.removeChild(s); });
        }
      });
      document.addEventListener('pointerup', release);
      document.addEventListener('pointercancel', release);
    })();
  });
})();
